exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".success-message{border:1px solid green;border-radius:3px;box-shadow:0 2px 4px rgba(0,0,0,.04);color:#006400;display:flex;font-family:Avenir,Lato,sans-serif;font-size:.9rem;font-weight:500;justify-content:space-between;margin:1rem 0;padding:.75rem}.success-message .success-text{flex:1}.success-message .success-close{cursor:pointer;width:22px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-74e2347d!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/SuccessMessage.vue
// module id = 943
// module chunks = 0